import { useEffect, useContext, useState } from 'react';
import { getActiveUtterance } from '../../utils/transcriptUtils';
import { getUtteranceId } from '../../utils/idHelpers';
import { TranscriptContext } from '../../contexts/TranscriptContext';
import { MediaPlaybackTimeContext } from '../../media-player/context/MediaPlaybackTimeContext';
export const ActiveUtteranceUpdater = props => {
  const {
    containerId
  } = props;
  const currentTime = useContext(MediaPlaybackTimeContext);
  const {
    setSelectedUtteranceId,
    setSelectedUtteranceIndex,
    highlightedOrFullTranscript
  } = useContext(TranscriptContext);
  const [currentUtteranceInfo, setCurrentUtteranceInfo] = useState(null);
  useEffect(() => {
    // Check if currentTime is outside the bounds of the current utterance
    if (!currentUtteranceInfo || currentTime < currentUtteranceInfo.startTime || currentTime > currentUtteranceInfo.endTime) {
      const activeUtterance = getActiveUtterance(highlightedOrFullTranscript, currentTime);
      if (activeUtterance && activeUtterance.utterance) {
        const utteranceId = getUtteranceId(activeUtterance.utterance, containerId);

        // Update state with the new utterance's info
        setCurrentUtteranceInfo({
          utteranceId,
          startTime: activeUtterance.utterance.startTimeSeconds,
          endTime: activeUtterance.utterance.endTimeSeconds
        });
        setSelectedUtteranceId(utteranceId);
        if (activeUtterance.index !== undefined) {
          setSelectedUtteranceIndex(activeUtterance.index);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTime, highlightedOrFullTranscript]);
  return null;
};